const classToggleSorted = 'data-table__sort--is-sorted',
    classToggleSortedAsc = 'data-table__sort--sort-asc',
    classToggleSortedDesc = 'data-table__sort--sort-desc',
    classHeaderSorted = 'data-table__header--is-sorted';

function comparer(index) {
    return function(a, b) {
        let valA = getCellValue(a, index),
            valB = getCellValue(b, index);

        return $.isNumeric(valA) && $.isNumeric(valB) ? valA - valB : valA.toString().localeCompare(valB);
    }
}

function getCellValue(row, index) {
    return $(row).children('td').eq(index).text();
}

$('.data-table--sortable .data-table__sort').on('click', function () {
    let $toggle = $(this),
        $header = $(this).closest('th'),
        $table = $(this).closest('.data-table--sortable'),
        columnIndex = $(this).closest('th').index(),
        $rows = $table.find('tbody tr').toArray().sort(comparer(columnIndex));

    this.asc = !this.asc;

    if (!this.asc) {
        $rows = $rows.reverse();
        $toggle.addClass(classToggleSortedDesc).removeClass(classToggleSortedAsc);
    } else {
        $toggle.addClass(classToggleSortedAsc).removeClass(classToggleSortedDesc);
    }

    if (!$toggle.hasClass(classToggleSorted)) {
        $toggle.addClass(classToggleSorted);
        $header.addClass(classHeaderSorted);

        $table.find('.data-table__sort').not($toggle).removeClass(classToggleSorted).removeClass(classToggleSortedAsc).removeClass(classToggleSortedDesc);
        $table.find('th').not($header).removeClass(classHeaderSorted);
    }

    for (let i = 0; i < $rows.length; i++) {
        $table.append($rows[i]);
    }
});